export function flattenMessages(nestedMessages: any, prefix: string = '') {
  return Object.keys(nestedMessages).reduce((messages: string[], key: string) => {
    let value: Object | string = nestedMessages[key];
    let prefixedKey: any = prefix ? `${prefix}.${key}` : key;

    if (typeof value === 'string') {
      messages[prefixedKey] = value;
    } else {
      Object.assign(messages, flattenMessages(value, prefixedKey));
    }

    return messages;
  }, {});
}


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/utils/flattenMessages.ts